import * as React from 'react';
import { IPreviewHeaderProps } from './types';
import { PREVIEW_HEADER_CARDS_KEYS, PREVIEW_HEADER_TITLE } from './constants';
import { CLASS_PREVIEW } from '../../../constants';
import { getMessages } from '../../../../../../../store/constants';
import './_PreviewHeader.scss';

export function PreviewHeader ({
    cardsCount,
}: IPreviewHeaderProps) {
    const className = CLASS_PREVIEW + '-header';

    return <div className={className}>
        <span className={className + '__title'}>{PREVIEW_HEADER_TITLE}</span>
        <span className={className + '__cards'}>
            {getMessages().getPluralByKeys(cardsCount, PREVIEW_HEADER_CARDS_KEYS, null, cardsCount)}
        </span>
    </div>
}
